// ===================================================================
// KAIXO - Leaderboard Modal (Latido de la Fama)
// ===================================================================
// 3 scopes (global / local / nicho) × 3 ventanas (semana / mes / all).
// ===================================================================

import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import useLeaderboard from '../../hooks/useLeaderboard';
import LeaderboardIcon from './LeaderboardIcon';
import './LatidoDorado.css';

const NICHES = ['cocina', 'tecnologia', 'deportes', 'musica', 'educacion', 'negocios', 'arte', 'viajes'];

const dict = {
    español: {
        title: 'Latido de la Fama', close: 'Cerrar',
        global: '🌍 Global', local: '🏳️ Local', niche: '🎯 Nicho',
        week: 'Semana', month: 'Mes', all: 'Histórico',
        loading: 'Cargando ranking...',
        empty: 'Aún no hay creadores con Latidos Dorados en este ranking.',
        niches: { cocina: 'Cocina', tecnologia: 'Tecnología', deportes: 'Deportes', musica: 'Música', educacion: 'Educación', negocios: 'Negocios', arte: 'Arte', viajes: 'Viajes' }
    },
    inglés: {
        title: 'Heartbeat of Fame', close: 'Close',
        global: '🌍 Global', local: '🏳️ Local', niche: '🎯 Niche',
        week: 'Week', month: 'Month', all: 'All-time',
        loading: 'Loading ranking...',
        empty: 'No creators with Golden Heartbeats in this ranking yet.',
        niches: { cocina: 'Cooking', tecnologia: 'Tech', deportes: 'Sports', musica: 'Music', educacion: 'Education', negocios: 'Business', arte: 'Art', viajes: 'Travel' }
    },
    euskera: {
        title: 'Famaren Taupada', close: 'Itxi',
        global: '🌍 Globala', local: '🏳️ Lokala', niche: '🎯 Nitxoa',
        week: 'Astea', month: 'Hilabetea', all: 'Historikoa',
        loading: 'Rankina kargatzen...',
        empty: 'Oraindik ez dago Urrezko Taupadadun sortzailerik ranking honetan.',
        niches: { cocina: 'Sukaldaritza', tecnologia: 'Teknologia', deportes: 'Kirolak', musica: 'Musika', educacion: 'Hezkuntza', negocios: 'Negozioak', arte: 'Artea', viajes: 'Bidaiak' }
    },
    francés: {
        title: 'Battement de la Renommée', close: 'Fermer',
        global: '🌍 Global', local: '🏳️ Local', niche: '🎯 Niche',
        week: 'Semaine', month: 'Mois', all: 'Tout temps',
        loading: 'Chargement du classement...',
        empty: 'Aucun créateur avec Battements Dorés dans ce classement.',
        niches: { cocina: 'Cuisine', tecnologia: 'Tech', deportes: 'Sport', musica: 'Musique', educacion: 'Éducation', negocios: 'Business', arte: 'Art', viajes: 'Voyages' }
    },
    alemán: {
        title: 'Herzschlag des Ruhms', close: 'Schließen',
        global: '🌍 Global', local: '🏳️ Lokal', niche: '🎯 Nische',
        week: 'Woche', month: 'Monat', all: 'Gesamt',
        loading: 'Ranking lädt...',
        empty: 'Noch keine Creator mit Goldenen Herzschlägen in diesem Ranking.',
        niches: { cocina: 'Kochen', tecnologia: 'Technik', deportes: 'Sport', musica: 'Musik', educacion: 'Bildung', negocios: 'Business', arte: 'Kunst', viajes: 'Reisen' }
    },
    portugués: {
        title: 'Batimento da Fama', close: 'Fechar',
        global: '🌍 Global', local: '🏳️ Local', niche: '🎯 Nicho',
        week: 'Semana', month: 'Mês', all: 'Histórico',
        loading: 'A carregar ranking...',
        empty: 'Ainda não há criadores com Batimentos Dourados neste ranking.',
        niches: { cocina: 'Cozinha', tecnologia: 'Tecnologia', deportes: 'Desporto', musica: 'Música', educacion: 'Educação', negocios: 'Negócios', arte: 'Arte', viajes: 'Viagens' }
    },
    italiano: {
        title: 'Battito della Fama', close: 'Chiudi',
        global: '🌍 Globale', local: '🏳️ Locale', niche: '🎯 Nicchia',
        week: 'Settimana', month: 'Mese', all: 'Storico',
        loading: 'Caricamento classifica...',
        empty: 'Ancora nessun creator con Battiti Dorati in questa classifica.',
        niches: { cocina: 'Cucina', tecnologia: 'Tech', deportes: 'Sport', musica: 'Musica', educacion: 'Educazione', negocios: 'Business', arte: 'Arte', viajes: 'Viaggi' }
    },
    chino: {
        title: '名誉之心', close: '关闭',
        global: '🌍 全球', local: '🏳️ 本地', niche: '🎯 领域',
        week: '本周', month: '本月', all: '全部',
        loading: '加载排行榜...',
        empty: '此排行榜暂无拥有金色心跳的创作者。',
        niches: { cocina: '烹饪', tecnologia: '科技', deportes: '体育', musica: '音乐', educacion: '教育', negocios: '商业', arte: '艺术', viajes: '旅行' }
    },
    japonés: {
        title: '名誉のハートビート', close: '閉じる',
        global: '🌍 グローバル', local: '🏳️ ローカル', niche: '🎯 ニッチ',
        week: '週', month: '月', all: '全期間',
        loading: 'ランキングを読み込み中...',
        empty: 'このランキングにはまだゴールデンハートビートのクリエイターがいません。',
        niches: { cocina: '料理', tecnologia: 'テクノロジー', deportes: 'スポーツ', musica: '音楽', educacion: '教育', negocios: 'ビジネス', arte: 'アート', viajes: '旅行' }
    },
    árabe: {
        title: 'نبضة الشهرة', close: 'إغلاق',
        global: '🌍 عالمي', local: '🏳️ محلي', niche: '🎯 تخصص',
        week: 'الأسبوع', month: 'الشهر', all: 'الكل',
        loading: 'جاري تحميل الترتيب...',
        empty: 'لا يوجد بعد مبدعون بنبضات ذهبية في هذا الترتيب.',
        niches: { cocina: 'الطبخ', tecnologia: 'التقنية', deportes: 'الرياضة', musica: 'الموسيقى', educacion: 'التعليم', negocios: 'الأعمال', arte: 'الفن', viajes: 'السفر' }
    },
    hindi: {
        title: 'यश की धड़कन', close: 'बंद करें',
        global: '🌍 वैश्विक', local: '🏳️ स्थानीय', niche: '🎯 निच',
        week: 'सप्ताह', month: 'माह', all: 'सम्पूर्ण',
        loading: 'रैंकिंग लोड हो रही है...',
        empty: 'इस रैंकिंग में अभी तक गोल्डन धड़कन वाले क्रिएटर नहीं हैं।',
        niches: { cocina: 'खाना पकाना', tecnologia: 'तकनीक', deportes: 'खेल', musica: 'संगीत', educacion: 'शिक्षा', negocios: 'व्यवसाय', arte: 'कला', viajes: 'यात्रा' }
    },
    ruso: {
        title: 'Пульс Славы', close: 'Закрыть',
        global: '🌍 Глобальный', local: '🏳️ Локальный', niche: '🎯 Ниша',
        week: 'Неделя', month: 'Месяц', all: 'Всё время',
        loading: 'Загрузка рейтинга...',
        empty: 'Пока нет авторов с Золотыми Пульсами в этом рейтинге.',
        niches: { cocina: 'Кулинария', tecnologia: 'Технологии', deportes: 'Спорт', musica: 'Музыка', educacion: 'Образование', negocios: 'Бизнес', arte: 'Искусство', viajes: 'Путешествия' }
    },
    coreano: {
        title: '명예의 맥박', close: '닫기',
        global: '🌍 글로벌', local: '🏳️ 로컬', niche: '🎯 틈새',
        week: '주간', month: '월간', all: '전체',
        loading: '순위 로드 중...',
        empty: '이 순위에 아직 골든 맥박을 가진 크리에이터가 없습니다.',
        niches: { cocina: '요리', tecnologia: '기술', deportes: '스포츠', musica: '음악', educacion: '교육', negocios: '비즈니스', arte: '예술', viajes: '여행' }
    },
    turco: {
        title: 'Şöhretin Kalp Atışı', close: 'Kapat',
        global: '🌍 Global', local: '🏳️ Yerel', niche: '🎯 Niş',
        week: 'Hafta', month: 'Ay', all: 'Tüm zamanlar',
        loading: 'Sıralama yükleniyor...',
        empty: 'Bu sıralamada henüz Altın Kalp Atışı olan içerik üreticisi yok.',
        niches: { cocina: 'Yemek', tecnologia: 'Teknoloji', deportes: 'Spor', musica: 'Müzik', educacion: 'Eğitim', negocios: 'İş', arte: 'Sanat', viajes: 'Seyahat' }
    },
    indonesio: {
        title: 'Detak Ketenaran', close: 'Tutup',
        global: '🌍 Global', local: '🏳️ Lokal', niche: '🎯 Ceruk',
        week: 'Minggu', month: 'Bulan', all: 'Sepanjang masa',
        loading: 'Memuat peringkat...',
        empty: 'Belum ada kreator dengan Detak Jantung Emas di peringkat ini.',
        niches: { cocina: 'Masakan', tecnologia: 'Teknologi', deportes: 'Olahraga', musica: 'Musik', educacion: 'Pendidikan', negocios: 'Bisnis', arte: 'Seni', viajes: 'Perjalanan' }
    }
};

function getT() {
    try {
        const u = JSON.parse(localStorage.getItem('kaixo_user') || '{}');
        return dict[u.language] || dict['inglés'] || dict['español'];
    } catch { return dict['inglés']; }
}

function LeaderboardModal({ currentUser, onClose, onSelectCreator }) {
    const [scope, setScope] = useState('global');
    const [win, setWin] = useState('week');
    const [interest, setInterest] = useState('');
    const t = getT();

    const filter = {
        scope,
        window: win,
        country: scope === 'local' ? currentUser?.country : undefined,
        language: scope === 'local' ? currentUser?.language : undefined,
        interest: scope === 'nicho' ? interest : undefined
    };
    const { leaders, loading } = useLeaderboard(filter);

    return ReactDOM.createPortal(
        <div className="ld-leaderboard-overlay" onClick={onClose}>
            <div className="ld-leaderboard-modal" onClick={(e) => e.stopPropagation()}>
                <div className="ld-lb-header">
                    <h2 className="ld-lb-title">
                        <LeaderboardIcon size={20} /> <span>{t.title}</span>
                    </h2>
                    <button className="ld-lb-close" onClick={onClose} aria-label={t.close}>×</button>
                </div>

                <div className="ld-lb-tabs">
                    {[
                        { id: 'global', label: t.global },
                        { id: 'local', label: t.local },
                        { id: 'nicho', label: t.niche }
                    ].map(tab => (
                        <button
                            key={tab.id}
                            className={`ld-lb-tab ${scope === tab.id ? 'active' : ''}`}
                            onClick={() => setScope(tab.id)}
                        >{tab.label}</button>
                    ))}
                </div>

                <div className="ld-lb-tabs">
                    {[
                        { id: 'week', label: t.week },
                        { id: 'month', label: t.month },
                        { id: 'all', label: t.all }
                    ].map(tab => (
                        <button
                            key={tab.id}
                            className={`ld-lb-tab ${win === tab.id ? 'active' : ''}`}
                            onClick={() => setWin(tab.id)}
                        >{tab.label}</button>
                    ))}
                </div>

                {scope === 'nicho' && (
                    <div className="ld-lb-tabs">
                        {NICHES.map(n => (
                            <button
                                key={n}
                                className={`ld-lb-tab ${interest === n ? 'active' : ''}`}
                                onClick={() => setInterest(n === interest ? '' : n)}
                            >{t.niches?.[n] || n}</button>
                        ))}
                    </div>
                )}

                <div className="ld-lb-list">
                    {loading && <div className="ld-lb-empty">{t.loading}</div>}
                    {!loading && leaders.length === 0 && (
                        <div className="ld-lb-empty">{t.empty}</div>
                    )}
                    {!loading && leaders.map((c, idx) => (
                        <div
                            key={c._id}
                            className="ld-lb-item"
                            onClick={() => onSelectCreator?.(c)}
                        >
                            <span className={`ld-lb-rank ld-lb-rank-${idx + 1}`}>
                                {idx === 0 ? '🥇' : idx === 1 ? '🥈' : idx === 2 ? '🥉' : `#${idx + 1}`}
                            </span>
                            {c.avatar
                                ? <img src={c.avatar} alt="" className="ld-lb-avatar" />
                                : <div className="ld-lb-avatar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>{(c.name || '?')[0]}</div>
                            }
                            <div className="ld-lb-name">
                                {c.name}
                                {c.handle && <span className="ld-lb-handle">@{c.handle}</span>}
                            </div>
                            <div className="ld-lb-score">
                                {c.score}
                                <span className="ld-lb-score-detail">🥇{c.gold} 🥈{c.silver}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    );
}

export default LeaderboardModal;
